import React, { Component } from 'react'

import { useMutation, } from '@apollo/client';
import UsernameSearch from './UsernameSearch';
import {REGISTER_WORKSHOP } from '../../queries';


const RegisterWorkshopFormContainer = ({username, schoolType}) => {
    const [ registerWorkshop, { data, loading, error }] = useMutation(REGISTER_WORKSHOP);

    return (
        <RegisterWorkshopForm
            data={data}
            loading = {loading}
            register = {registerWorkshop}
            error = {error}/>
    );
}

class RegisterWorkshopForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCheckbox : false,
        };
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleSubmit =this.handleSubmit.bind(this);
        console.log(this.state);

    }
    isValid(event){
        return this.state.isCheckbox
    }

    handleCheckboxChange(event){
        const ay = this.state.isCheckbox;
        this.setState({
            isCheckbox: !ay
        });
        
    }


    async handleSubmit(event) {
        event.preventDefault();


        const o = { variables: {
          isCheckbox : this.state.isCheckbox
        }};

        try {
          await this.props.register(o);
          window.location = '/account';
        }
        catch (e) {
        }
    }

    render() {
        return (
            <div className="container">
                  <h3>Step 2 : Register to Workshop</h3>
                  <hr></hr>
                  <form className="mt-5" onSubmit={this.handleSubmit}>


                    <div className="form-group">
                        <h5 style={{wordBreak:"break-word"}}>Apakah anda bersedia mengikuti seluruh kegiatan workshop ini? Silahkan centang checkbox ini</h5>
                        <input
                            className="form-control shadow-sm"
                            placeholder="checkbox"
                            type="checkbox"
                            name="isCheckbox"

                            onChange={this.handleCheckboxChange} />
                    </div>

                    {this.props.error ? <p className="text-danger text-center">{this.props.error.message}</p> : <></>}
                    <button disabled={this.props.loading || !this.isValid() } className="btn btn-primary btn-block mt-3 shadow-sm" type="submit">Submit</button>
                  </form>
            </div>
        );
    }
}

export default RegisterWorkshopFormContainer;
